import React from "react";
import getPriceForGoogleView from "./getPriceForGoogleView";
import StandardPrice from "./StandardPrice";

interface Props {
  price: number;
  minimumBuy: number;
  mustBuy: number;
  divideByUnit?: string;
  divideQuantity?: number;
  showCreditKey?: boolean;
  priceCrossedOut?: boolean;
  unitOfMeasure?: string;
  divideByUnitCssClass?: string;
}

const GoogleViewPrice = ({
  price,
  minimumBuy,
  mustBuy,
  divideByUnit,
  divideQuantity,
  showCreditKey = true,
  priceCrossedOut = false,
  unitOfMeasure = "",
  divideByUnitCssClass = "text-xs block",
}: Props) => {
  return (
    <StandardPrice
      price={getPriceForGoogleView({
        price,
        minimumBuy,
        mustBuy,
      })}
      unitOfMeasure={unitOfMeasure}
      divideByUnit={divideByUnit}
      divideQuantity={divideQuantity}
      showCreditKey={showCreditKey}
      priceCrossedOut={priceCrossedOut}
      divideByUnitCssClass={divideByUnitCssClass}
    />
  );
};

export default GoogleViewPrice;
